export default __webpack_public_path__ + "assets/images/ba9d0141008ec216ca89b990f7843bcd.svg";